// extracted by mini-css-extract-plugin
export default {"desktopMap":"desktopMap__Sjn0z","content":"content__wAVR0","image":"image__bBQGB","description":"description__CzkzF","habitatSelected":"habitatSelected__VNZet","card":"card__yhOdT"};